<form
  *ngIf="formInitialized"
  [formGroup]="form"
  (ngSubmit)="onSubmit()"
  class="p-fluid">
  <div class="grid">
    <app-form-field-wrapper
      [label]="'Name'"
      [name]="'name'"
      [colSize]="8"
      [formField]="form.get('name')">
      <input
        pInputText
        id="name"
        type="text"
        formControlName="name"
        class="p-input" />
    </app-form-field-wrapper>
    <app-form-field-wrapper
      [label]="'Schlüssel'"
      [name]="'key'"
      [colSize]="4"
      [formField]="form.get('key')">
      <input
        pInputText
        id="key"
        type="text"
        formControlName="key"
        class="p-input" />
    </app-form-field-wrapper>

    <app-form-field-wrapper
      [label]="'Titel'"
      [name]="'title'"
      [colSize]="12"
      [formField]="form.get('title')">
      <input
        pInputText
        id="title"
        type="text"
        formControlName="title"
        class="p-input" />
    </app-form-field-wrapper>
    <app-form-field-wrapper
      [label]="'Inhalt'"
      [floatingLabel]="false"
      [name]="'content'">
      <p-editor
        formControlName="content"
        [modules]="{ nbspFix: true }"
        [style]="{ height: '300px' }">
        <ng-template pTemplate="header">
          <span class="ql-formats">
            <button class="ql-bold"></button>
            <button class="ql-italic"></button>
            <button class="ql-underline"></button>
            <button type="button" class="ql-link" aria-label="Link"></button>
            <button class="ql-image"></button>
            <button class="ql-video"></button>
          </span>
        </ng-template>
      </p-editor>
    </app-form-field-wrapper>

    <app-form-field-wrapper
      [label]="'Keywords'"
      [name]="'keywords'"
      [colSize]="12"
      [formField]="form.get('keywords')">
      <p-chips formControlName="keywords" />
    </app-form-field-wrapper>
  </div>

  <p-divider></p-divider>
  <app-form-footer
    [hideCancelLink]="true"
    [showRemoveButton]="!!itemToEdit"
    [isEditMode]="!!itemToEdit"
    (removeClick)="
      itemToEdit ? confirm(undefined, itemToEdit, itemToEdit.name) : undefined
    "></app-form-footer>
</form>
